"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StaticChatPreview = function StaticChatPreview(_ref) {
  var onSelect = _ref.onSelect,
    title = _ref.title,
    isActive = _ref.isActive;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "chat-preview"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__channel-preview",
    onClick: onSelect
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": "channel-preview-button"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__avatar str-chat__avatar--circle",
    "data-testid": "avatar",
    title: title,
    style: {
      flexBasis: '32px',
      fontSize: '16px',
      height: '32px',
      lineHeight: '32px',
      width: '32px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__avatar-fallback",
    "data-testid": "avatar-fallback"
  }, title[0])), /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__channel-preview-info"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "str-chat__channel-preview-title"
  }, title))))));
};
var _default = StaticChatPreview;
exports.default = _default;